/**
 * Encore Foundation - 5.14.2
 *
 * The contents of this file is owned and generated by the Encore team.
 * If you need to make changes to the values stored here please reach out
 * to #encore on Slack.
 *
 * Links:
 *
 * - Source & Documentation: https://ghe.spotify.net/encore/foundation
 *
 * Tack!
 *
 * Encore
 * encore.spotify.net
 */
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * Used for standard interface items and long passages of text
 */
export var desktopBallad = {
    fontSize: '1rem',
    fontFamily: 'CircularSp,CircularSp-Arab,CircularSp-Hebr,CircularSp-Cyrl,CircularSp-Grek,CircularSp-Deva, var(--fallback-fonts, sans-serif)',
    fontWeight: 400
};
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * Used to enhance the visual hierarchy of small-scale typographic relationships in standard interface items
 */
export var desktopBalladBold = {
    fontSize: '1rem',
    fontFamily: 'CircularSp,CircularSp-Arab,CircularSp-Hebr,CircularSp-Cyrl,CircularSp-Grek,CircularSp-Deva, var(--fallback-fonts, sans-serif)',
    fontWeight: 700
};
/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use Mesto for a clearer distinction with Ballad
 */
export var desktopViola = {
    fontSize: '0.875rem',
    fontFamily: 'CircularSp,CircularSp-Arab,CircularSp-Hebr,CircularSp-Cyrl,CircularSp-Grek,CircularSp-Deva, var(--fallback-fonts, sans-serif)',
    fontWeight: 400
};
/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use Mesto Bold for a clearer distinction with Ballad Bold
 */
export var desktopViolaBold = {
    fontSize: '0.875rem',
    fontFamily: 'CircularSp,CircularSp-Arab,CircularSp-Hebr,CircularSp-Cyrl,CircularSp-Grek,CircularSp-Deva, var(--fallback-fonts, sans-serif)',
    fontWeight: 700
};
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * Used for details, such as metadata
 */
export var desktopMesto = {
    fontSize: '0.875rem',
    fontFamily: 'CircularSp,CircularSp-Arab,CircularSp-Hebr,CircularSp-Cyrl,CircularSp-Grek,CircularSp-Deva, var(--fallback-fonts, sans-serif)',
    fontWeight: 400
};
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * Used to enhance the visual hierarchy of small-scale typographic relationships in details, such as metadata
 */
export var desktopMestoBold = {
    fontSize: '0.875rem',
    fontFamily: 'CircularSp,CircularSp-Arab,CircularSp-Hebr,CircularSp-Cyrl,CircularSp-Grek,CircularSp-Deva, var(--fallback-fonts, sans-serif)',
    fontWeight: 700
};
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * Used for short high-emphasis screen titles where space is generous
 */
export var desktopBass = {
    fontSize: '6rem',
    fontFamily: 'CircularSpTitle,CircularSpTitle-Tall,CircularSp-Arab,CircularSp-Hebr,CircularSp-Cyrl,CircularSp-Grek,CircularSp-Deva, var(--fallback-fonts, sans-serif)',
    fontWeight: 900
};
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * Used for short medium-emphasis screen titles where space is generous
 */
export var desktopForte = {
    fontSize: '4.5rem',
    fontFamily: 'CircularSpTitle,CircularSpTitle-Tall,CircularSp-Arab,CircularSp-Hebr,CircularSp-Cyrl,CircularSp-Grek,CircularSp-Deva, var(--fallback-fonts, sans-serif)',
    fontWeight: 900
};
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * Used for short low-emphasis screen titles where space is generous
 */
export var desktopBrio = {
    fontSize: '3rem',
    fontFamily: 'CircularSpTitle,CircularSpTitle-Tall,CircularSp-Arab,CircularSp-Hebr,CircularSp-Cyrl,CircularSp-Grek,CircularSp-Deva, var(--fallback-fonts, sans-serif)',
    fontWeight: 700
};
/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated In order to better support non-latin languages, the all-caps type styles have been deprecated. You can learn more about the reasons and replacements on http://go/all-caps-deprecation
 */
export var desktopMetronome = {
    fontSize: '0.875rem',
    fontFamily: 'CircularSp,CircularSp-Arab,CircularSp-Hebr,CircularSp-Cyrl,CircularSp-Grek,CircularSp-Deva, var(--fallback-fonts, sans-serif)',
    fontWeight: 700,
    letterSpacing: '0.1em',
    textTransform: 'uppercase'
};
/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated In order to better support non-latin languages, the all-caps type styles have been deprecated. You can learn more about the reasons and replacements on http://go/all-caps-deprecation
 */
export var desktopMinuet = {
    fontSize: '0.75rem',
    fontFamily: 'CircularSp,CircularSp-Arab,CircularSp-Hebr,CircularSp-Cyrl,CircularSp-Grek,CircularSp-Deva, var(--fallback-fonts, sans-serif)',
    fontWeight: 400,
    letterSpacing: '0.1em',
    textTransform: 'uppercase'
};
/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated In order to better support non-latin languages, the all-caps type styles have been deprecated. You can learn more about the reasons and replacements on http://go/all-caps-deprecation
 */
export var desktopMinuetBold = {
    fontSize: '0.75rem',
    fontFamily: 'CircularSp,CircularSp-Arab,CircularSp-Hebr,CircularSp-Cyrl,CircularSp-Grek,CircularSp-Deva, var(--fallback-fonts, sans-serif)',
    fontWeight: 700,
    letterSpacing: '0.1em',
    textTransform: 'uppercase'
};
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * Used for a text that is rarely read, such as legal copy
 */
export var desktopFinale = {
    fontSize: '0.6875rem',
    fontFamily: 'CircularSp,CircularSp-Arab,CircularSp-Hebr,CircularSp-Cyrl,CircularSp-Grek,CircularSp-Deva, var(--fallback-fonts, sans-serif)',
    fontWeight: 400
};
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * Used to enhance the visual hierarchy of small-scale typographic relationships in text that is rarely read, such as legal copy
 */
export var desktopFinaleBold = {
    fontSize: '0.6875rem',
    fontFamily: 'CircularSp,CircularSp-Arab,CircularSp-Hebr,CircularSp-Cyrl,CircularSp-Grek,CircularSp-Deva, var(--fallback-fonts, sans-serif)',
    fontWeight: 700
};
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * Used for screen titles where space is compact in specific responsive web use-cases
 */
export var desktopAltoBrio = {
    fontSize: '3rem',
    fontFamily: 'CircularSpTitle,CircularSpTitle-Tall,CircularSp-Arab,CircularSp-Hebr,CircularSp-Cyrl,CircularSp-Grek,CircularSp-Deva, var(--fallback-fonts, sans-serif)',
    fontWeight: 700
};
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * Used for screen titles where space is compact
 */
export var desktopAlto = {
    fontSize: '2rem',
    fontFamily: 'CircularSpTitle,CircularSpTitle-Tall,CircularSp-Arab,CircularSp-Hebr,CircularSp-Cyrl,CircularSp-Grek,CircularSp-Deva, var(--fallback-fonts, sans-serif)',
    fontWeight: 700
};
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * Used for section titles
 */
export var desktopCanon = {
    fontSize: '1.5rem',
    fontFamily: 'CircularSpTitle,CircularSpTitle-Tall,CircularSp-Arab,CircularSp-Hebr,CircularSp-Cyrl,CircularSp-Grek,CircularSp-Deva, var(--fallback-fonts, sans-serif)',
    fontWeight: 700
};
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * Used for subsections in specific responsive web use-cases
 */
export var desktopCelloCanon = {
    fontSize: '1.5rem',
    fontFamily: 'CircularSpTitle,CircularSpTitle-Tall,CircularSp-Arab,CircularSp-Hebr,CircularSp-Cyrl,CircularSp-Grek,CircularSp-Deva, var(--fallback-fonts, sans-serif)',
    fontWeight: 700
};
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * Used for subsections
 */
export var desktopCello = {
    fontSize: '1.125rem',
    fontFamily: 'CircularSp,CircularSp-Arab,CircularSp-Hebr,CircularSp-Cyrl,CircularSp-Grek,CircularSp-Deva, var(--fallback-fonts, sans-serif)',
    fontWeight: 700
};
